import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Store } from "../../../Store";
import ImageImports from '../../../utils/ImageImports';
import { NavLinksProps } from "../InterfaceMobile";


const MobileSubmenuLink = (props: NavLinksProps) => { 

  const {menuOpen} = ImageImports;  
  const stateContext = useContext(Store);
  const {mobileNavToggle,toggleMobileNav} = stateContext;
  const [clicked, setClicked] = useState("0");  
  const handleToggle = (index:any) => {
    if (clicked === index) {
      return setClicked("0");
    }
    setClicked(index);
  };

  return (
    <div className="mobile-nav-item" key={props.id}>
      <div
        className={
          props.subRoutes ? `has-dropdown ${props.cName}` : props.cName 
        }
        onClick={() => handleToggle(props.index)}
      >
        <div className="menu-icon">
          <img src={props.icon} alt={props.title} />
        </div>
        <div>{props.title}</div>
        {props.subRoutes && (
          <img className={clicked === props.index ? " menu-toggle-icon active" : "menu-toggle-icon"} src={menuOpen} alt="open" />
        )}
      </div>
      
      <div 
      
      className={`${clicked === props.index ? "nav-dropdown" : "hide nav-dropdown"}`}
      >
      { 
        props.subRoutes && props.subRoutes.map((subrout,i) => (
            
            <Link 
              key={i}to={subrout.route}
              onClick={() => {                
                toggleMobileNav && toggleMobileNav(!mobileNavToggle);
                setClicked("0")
              }}
              className="submobile-menu">              
            {subrout.title}
          </Link>
        ))
      }
      </div>
    </div>
  );
};

export default MobileSubmenuLink;